import React, { FC } from 'react';
import isVideoBlocked from '../../helpers/isVideoBlocked';
import { AppProps, VideoStatusCode } from '../../types';

import { usePlayerData } from '../App/hooks';
import PlayerBlock from '../PlayerBlock';

const AppContent: FC<AppProps & { playerWidth: number }> = ({
  manifest,
  password,
  playerWidth,
  canDestroy,
  parentVideoData,
  webinarOwner,
  stream,
  target,
  onInit,
  chatProps,
  onTimeChange,
  isChatMobileView,
  startTime,
  ...otherProps
}) => {
  const { videoId, isPopover } = otherProps;
  const hostId = otherProps.videoId === 'blocked' ? '' : otherProps.videoId;

  const [videoInfo, isPending, setPassword] = usePlayerData({
    hostId,
    manifest,
    playerWidth,
    parentVideoData,
    ...otherProps
  });

  const isParentDataExist = !!parentVideoData;

  const isBlocked = isVideoBlocked(manifest);
  const color = videoInfo?.color || videoInfo?.videoData?.configs.playerColor;

  return (
    <PlayerBlock
      onSubmit={setPassword}
      videoData={videoInfo?.videoData}
      isDisabledSubmit={isParentDataExist}
      errorCode={isBlocked ? VideoStatusCode.blocked : videoInfo?.errorCode}
      errorMessage={videoInfo?.errorMessage}
      {...{
        color,
        stream,
        onInit,
        target,
        videoId,
        password,
        chatProps,
        isPopover,
        startTime,
        isPending,
        canDestroy,
        playerWidth,
        onTimeChange,
        webinarOwner,
        isChatMobileView
      }}
    />
  );
};

export default AppContent;
